<h2 mat-dialog-title>{{dialogTitle}}</h2>
<mat-divider></mat-divider>
<form class="example-form">
  <mat-form-field appearance="fill">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="description" name="description">
  </mat-form-field>
</form>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="onOk()" [mat-dialog-close]="data.brand">Ok</button>
</mat-dialog-actions>
